import React from 'react';

const SvgGPayLogo = (props) => (
  <svg data-name="Layer 1" width="1em" height="1em" viewBox="0 0 297.559 301.877" {...props}>
    <path
      d="M206.847 83.997a86.847 86.847 0 00-58.068-22.23c-48.543 0-87.895 39.924-87.895 89.172s39.352 89.17 87.895 89.17c37.812 0 70.047-24.222 82.452-58.206H151.058v-57.126h140.437l3.835-.004a154.034 154.034 0 012.228 26.166c0 83.36-66.611 150.938-148.78 150.938S0 234.3 0 150.94 66.61 0 148.78 0a147.091 147.091 0 01100.78 39.902l-.007.006z"
      fill="currentColor"
    />
  </svg>
);

export default SvgGPayLogo;
